import getExportConfigurationHistory from '@hooks/configuration/getExportConfigurationHistory';

const useExportConfigurationHistory = ({ id }) => {
    const fileName = 'configuration_history.xlsx';
    return getExportConfigurationHistory({ fileName, id });
};

export default useExportConfigurationHistory;
